import React from "react";
import { CheckboxItem } from "./CheckboxItem";

/** PowerLego save field. Backend maps this to Constellation SmsAgreement. */
export const SMS_MARKETING_CONSENT_FIELD = "sms_marketing_consent";

/**
 * PowerLego save field for the new informational checkbox.
 * Backend must map this to Constellation SmsInformationalAgreement.
 */
export const SMS_INFORMATIONAL_CONSENT_FIELD = "sms_informational_consent";

const INFORMATIONAL_COPY =
  "By checking this box, I agree to receive recurring automated transactional/informational text messages and communications regarding account notifications, customer care, etc. from Constellation. Message frequency may vary. Message and data rates may apply. Reply STOP to opt-out.";

const MARKETING_COPY =
  "By checking this box, I agree to receive recurring automated marketing text messages and automated/prerecorded marketing calls from Constellation to the phone number provided in this form. I understand that providing consent is not a condition of completing this transaction. Message frequency may vary. Message and data rates may apply. Reply STOP to opt-out.";

type SmsConsentAgreementsProps = {
  informationalChecked: boolean;
  marketingChecked: boolean;
  onToggleInformational: () => void;
  onToggleMarketing: () => void;
  disabled: boolean;
};

export const SmsConsentAgreements: React.FC<SmsConsentAgreementsProps> = ({
  informationalChecked,
  marketingChecked,
  onToggleInformational,
  onToggleMarketing,
  disabled,
}) => {
  return (
    <>
      <div className="checkbox-row">
        <p style={{ fontSize: "1.1rem" }}>
          Check the boxes below to opt in to text messages from Constellation.
        </p>
        <CheckboxItem
          label=""
          value={`${informationalChecked}`}
          checked={informationalChecked}
          handleClick={onToggleInformational}
          onlyread={false}
          disabled={disabled}
          id="sms-informational-agreement"
          renderLabel={() => <span>{INFORMATIONAL_COPY}</span>}
        />
      </div>
      <div className="checkbox-row">
        <CheckboxItem
          label=""
          value={`${marketingChecked}`}
          checked={marketingChecked}
          handleClick={onToggleMarketing}
          onlyread={false}
          disabled={disabled}
          id="sms-marketing-agreement"
          renderLabel={() => <span>{MARKETING_COPY}</span>}
        />
      </div>
    </>
  );
};
